import {
	EDIT_PRE_CALCULATED_DATA,
	EDIT_PRE_CALCULATED_DATA_SUCCESS,
	EDIT_PRE_CALCULATED_DATA_FAIL,
	EDIT_PRE_CALCULATED_DATA_RESET,
} from '../actions/editPreCalculatedDataAction';

const initialState = {
	apiState: '',
	message: '',
	data: null,
	error: '',
};

const editPreCalculatedDataReducer = (state = initialState, action) => {
	switch (action.type) {
		case EDIT_PRE_CALCULATED_DATA:
			return {
				...state,
				apiState: 'loading',
			};
		case EDIT_PRE_CALCULATED_DATA_SUCCESS:
			return {
				...state,
				apiState: 'success',
				data: action.response.data,
				message: action.response.message
					? action.response.message
					: 'success',
			};
		case EDIT_PRE_CALCULATED_DATA_FAIL:
			return {
				...state,
				apiState: 'error',
				error: action.response.errors,
				message: action.response.message
					? action.response.message
					: 'error',
			};
		case EDIT_PRE_CALCULATED_DATA_RESET:
			return initialState;
		default:
			return state;
	}
};

export default editPreCalculatedDataReducer;
